import React from "react";
import { Link } from "react-router-dom";

import "./styles/footer.css";

const Footer = () => {
	return (
		<React.Fragment>
			<div className="footer">
				<div className="footer-links">
					<ul className="footer-nav-link-list">
						<li className="footer-nav-link-item">
							<Link to="/">Bio</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/writer">Writer</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/director">Director</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/actor">Actor</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/producer">Producer</Link>
						</li>
						<li className="footer-nav-link-item">
							<Link to="/editor">Editor</Link>
						</li>
					</ul>
				</div>

				<div className="footer-credits">
					<div className="footer-credits-text">
						© {new Date().getFullYear()} Hamoun Dolatshahi. All Rights Reserved.
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Footer;
